module.exports = __webpack_public_path__ + "img/bigCourse.ccc165fa.jpeg";